import { useEffect } from 'react'

import type { useMeQuery } from '@/src/features/auth/services/useMeQuery'

import { storage } from '../general/utilities/storage'
import { STORAGE_KEYS } from '../general/utilities/storage/MMKVStorage'
import { isSupportedLocale } from './getLocale'
import { resolveRootLocale } from './resolveRootLocale'

/**
 * Custom hook to determine and persist the user's locale (language).
 *
 * Priority: account language, then UTM language (from `utm_source` suffix),
 * then localStorage, then browser.
 */
export const useRootLocale = (me?: ReturnType<typeof useMeQuery>, utmSource?: string) => {
  const storedStringLocale = storage.getItem(STORAGE_KEYS.LANG)
  const storedLocale = isSupportedLocale(storedStringLocale) ? storedStringLocale : undefined
  const userLang = me?.data?.lang

  const locale = resolveRootLocale({ userLang, utmSource, storedLocale })

  useEffect(() => {
    storage.setItem(STORAGE_KEYS.LANG, locale)
  }, [locale])

  return locale
}
